export default (state, action) => {
  switch (action.type) {
      case "ADD_IMAGE_URL":
          return { ...state, imageUrl: action.imageUrl };
      default:
          return state;
  }
}
